import { Box, Container } from "@mui/material";
import { SectionHeading } from "./SectionHeading";

// Base layout for inner pages; the top padding clears the fixed navbar
export function PageSection({ overline, title, subtitle, children }) {
  return (
    <Box
      component="main"
      sx={{
        minHeight: "100vh",
        "@supports (min-height: 100dvh)": { minHeight: "100dvh" },
        overflowX: "hidden",
        pt: { xs: 14, md: 20 },
        pb: { xs: 8, md: 12 },
        background: (theme) =>
          `radial-gradient(ellipse at top, ${theme.palette.primary.main}1f 0%, transparent 55%)`,
      }}
    >
      <Container maxWidth="lg">
        <SectionHeading overline={overline} title={title} subtitle={subtitle} component="h1" />
        {children}
      </Container>
    </Box>
  );
}
